/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
import styled from '@emotion/styled';
import { type ReactNode } from 'react';
import { type Spacing, breakpoint, colors, spacing, typography } from '../../../themes';

type HeadingProps = {
  as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5';
  variant: 'small' | 'sCaps' | 'medium' | 'large' | 'xLarge' | 'mega';
  align?: 'left' | 'center' | 'right';
  mt?: string | Spacing;
  mb?: string | Spacing;
  color?: string;
  children?: ReactNode;
  testId?: string;
  id?: string;
};

export const Heading = ({ mt, mb, children, testId, ...rest }: HeadingProps) => {
  const isSpacingSyntax = (value: string | Spacing): value is Spacing => {
    return typeof value === 'string' && value in spacing;
  };

  if (mb && isSpacingSyntax(mb)) {
    mb = spacing[mb];
  }

  if (mt && isSpacingSyntax(mt)) {
    mt = spacing[mt];
  }

  return (
    <StyledHeading data-testid={testId} mt={mt} mb={mb} {...rest}>
      {children}
    </StyledHeading>
  );
};

const StyledHeading = styled.h1<HeadingProps>`
  color: ${({ color }) => color ?? colors.base.black};
  ${({ align }) => align && `text-align: ${align};`}
  ${({ variant }) => typography.heading.desktop[variant]}
  @media (max-width: ${breakpoint.medium}px) {
    ${({ variant }) => typography.heading.mobile[variant]}
  }

  margin-top: ${({ mt }) => mt ?? '0px'};
  margin-bottom: ${({ mb }) => mb ?? '0px'};
`;
